import React from "react";
import LanguageContext from "../../../context/languagecontext";
import Styles from "./Footer.module.scss";

const Footer = () => {
  const { language } = React.useContext(LanguageContext);
  return (
    <footer className={Styles.footer}>
      <div className={Styles.container}>
        <div className={Styles.row}>
          <div className={`${Styles.col} ${Styles.logoCol}`}>
            <div className={Styles.row}>
              <div className={Styles.col}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 113.38 27.86"
                  className={Styles.logo}
                >
                  <path
                    fill="#ffffff"
                    d="M45.44 24.03c-5.57 0-10.1-4.53-10.1-10.1 0-5.57 4.53-10.1 10.1-10.1 5.57 0 10.1 4.53 10.1 10.1 0 5.57-4.53 10.1-10.1 10.1zm0-18.7c-4.74 0-8.6 3.86-8.6 8.6s3.86 8.6 8.6 8.6 8.6-3.86 8.6-8.6-3.85-8.6-8.6-8.6zM32.07 14.68H.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h31.32c.41 0 .75.34.75.75s-.34.75-.75.75z"
                  />
                  <g fill="#ffffff">
                    <path d="M88.95 3.43c.26.28.65.42 1.17.42.51 0 .9-.14 1.16-.42.26-.28.39-.63.39-1.05 0-.43-.13-.79-.39-1.08-.26-.3-.65-.45-1.16-.45-.52 0-.91.15-1.17.44-.26.29-.39.66-.39 1.08 0 .43.13.78.39 1.06M83.75 8.61h5.15v10.65h-5.15v2.24h12.68v-2.24h-4.94V6.36h-7.74zM68.3 6.36h-2.66l6.23 15.14h1.98l6.17-15.14h-2.65l-4.24 11.42-.25.94-.24-.94zM112.99 10.69c-.26-.95-.64-1.76-1.15-2.44-.5-.68-1.13-1.21-1.88-1.6-.75-.38-1.61-.57-2.58-.57-.93 0-1.75.16-2.45.49-.7.33-1.3.8-1.79 1.41V0h-2.59v21.5h2.38l.13-1.72c.5.64 1.11 1.14 1.83 1.48.71.35 1.56.52 2.53.52.96 0 1.81-.2 2.56-.59.74-.39 1.36-.93 1.87-1.62.5-.69.89-1.51 1.15-2.44.26-.94.39-1.95.39-3.03v-.3c-.01-1.12-.14-2.16-.4-3.11zm-2.2 3.41c0 .74-.08 1.44-.23 2.1-.15.66-.39 1.25-.71 1.75-.32.5-.74.9-1.25 1.2-.51.29-1.12.44-1.83.44-.45 0-.86-.06-1.23-.18a3.53 3.53 0 0 1-1.01-.5c-.3-.21-.56-.46-.79-.75-.23-.28-.43-.6-.59-.93v-6.62c.16-.34.35-.65.58-.93.23-.28.49-.53.78-.74.29-.21.63-.37 1-.49s.78-.18 1.23-.18c.75 0 1.38.15 1.89.45.51.3.93.7 1.25 1.21.32.51.55 1.1.69 1.76.14.67.22 1.37.22 2.11v.3z" />
                  </g>
                </svg>
              </div>
            </div>
          </div>

          <div className={`${Styles.col} ${Styles.infoCol}`}>
            <div className={Styles.row}>
              <div className={Styles.col}>
                <p>
                  vib GmbH
                  <br />
                  Grabenstrasse 12
                  <br />
                  6340 Baar
                </p>
              </div>

              <div className={Styles.col}>
                <p>
                  <a href="tel:+41417631694">
                    {language === "fr"
                      ? "Tél: +41 41 763 16 94"
                      : language === "it"
                      ? "Tel: +41 41 763 16 94"
                      : "Tel: +41 41 763 16 94"}
                  </a>
                  <br />
                  <a href="mailto:support@vib-gmbh.ch">support@vib-gmbh.ch</a>
                </p>
              </div>

              <div className={Styles.col}>
                <p>
                  <a
                    href="https://www.vib-gmbh.ch/impressum/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {language === "fr"
                      ? "Mentions légales"
                      : language === "it"
                      ? "Impronta"
                      : "Impressum"}
                  </a>
                  <br />
                  <a
                    href="https://www.vib-gmbh.ch/datenschutzerklaerung/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {language === "fr"
                      ? "Politique de confidentialité"
                      : language === "it"
                      ? "Informativa sulla privacy"
                      : "Datenschutzerklärung"}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
